module.exports = __webpack_public_path__ + "static/media/Room.e0c33287.jpg";